import {Injectable} from '@angular/core';
import {randomUUIDGenerator} from 'app/core/helpers/uuid';
import {BehaviorSubject} from 'rxjs';
import {Alert, AlertStatus} from '../../interfaces/alert.interface';

@Injectable({
    providedIn: 'root',
})
export class LocalAlertsService {
    public readonly alerts$ = new BehaviorSubject<Alert[]>([]);

    get alerts(): Alert[] {
        return this.alerts$.getValue();
    }

    constructor() {}

    addAlert(body, status = AlertStatus.error, onClose?) {
        if (this.alerts.some(a => a.body === body)) {
            return;
        }

        const newAlert = {
            id: randomUUIDGenerator(),
            status,
            body,
            global: false,
            onClose,
        };

        this.alerts$.next([...this.alerts, newAlert]);
        return newAlert;
    }

    dismiss(alert: Alert) {
        if (this.alerts.includes(alert)) {
            this.alerts$.next(this.alerts.filter(item => item !== alert));
            return true;
        }
    }
}
